import { Maybe } from "@shared/graphql.types";

export const fromMaybe = <T>(value: Maybe<T> | undefined): T | undefined => {
  return value === null ? undefined : value;
};
